import x, { Children as w, cloneElement as z, PureComponent as F } from "react";
import a from "../../../_virtual/index7.js";
import { deepEqual as H } from "../../fast-equals/dist/esm/index.js";
import L from "./AnimateManager.js";
import { configEasing as V } from "./easing.js";
import G from "./configUpdate.js";
import { getTransitionVal as J, identity as Q } from "./util.js";
function A(t) {
  "@babel/helpers - typeof";
  return A = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, A(t);
}
var X = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function Y(t, n) {
  if (t == null) return {};
  var r = Z(t, n), o, e;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (e = 0; e < i.length; e++)
      o = i[e], !(n.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(t, o) && (r[o] = t[o]);
  }
  return r;
}
function Z(t, n) {
  if (t == null) return {};
  var r = {}, o = Object.keys(t), e, i;
  for (i = 0; i < o.length; i++)
    e = o[i], !(n.indexOf(e) >= 0) && (r[e] = t[e]);
  return r;
}
function E(t) {
  return it(t) || nt(t) || et(t) || tt();
}
function tt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function et(t, n) {
  if (t) {
    if (typeof t == "string") return R(t, n);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return R(t, n);
  }
}
function nt(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function it(t) {
  if (Array.isArray(t)) return R(t);
}
function R(t, n) {
  (n == null || n > t.length) && (n = t.length);
  for (var r = 0, o = new Array(n); r < n; r++) o[r] = t[r];
  return o;
}
function C(t, n) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    n && (o = o.filter(function(e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function d(t) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? C(Object(r), !0).forEach(function(o) {
      O(t, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : C(Object(r)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return t;
}
function O(t, n, r) {
  return n = U(n), n in t ? Object.defineProperty(t, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[n] = r, t;
}
function rt(t, n) {
  if (!(t instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function ot(t, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, U(o.key), o);
  }
}
function at(t, n, r) {
  return n && ot(t.prototype, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function U(t) {
  var n = ut(t, "string");
  return A(n) === "symbol" ? n : String(n);
}
function ut(t, n) {
  if (A(t) !== "object" || t === null) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var o = r.call(t, n);
    if (A(o) !== "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(t);
}
function st(t, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(n && n.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), n && T(t, n);
}
function T(t, n) {
  return T = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, e) {
    return o.__proto__ = e, o;
  }, T(t, n);
}
function ft(t) {
  var n = ct();
  return function() {
    var o = j(t), e;
    if (n) {
      var i = j(this).constructor;
      e = Reflect.construct(o, arguments, i);
    } else
      e = o.apply(this, arguments);
    return N(this, e);
  };
}
function N(t, n) {
  if (n && (A(n) === "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return k(t);
}
function k(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function ct() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function j(t) {
  return j = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, j(t);
}
var B = /* @__PURE__ */ function(t) {
  st(r, t);
  var n = ft(r);
  function r(o, e) {
    var i;
    rt(this, r), i = n.call(this, o, e);
    var s = i.props, p = s.isActive, u = s.attributeName, f = s.from, l = s.to, y = s.steps, c = s.children, h = s.duration;
    if (i.handleStyleChange = i.handleStyleChange.bind(k(i)), i.changeStyle = i.changeStyle.bind(k(i)), !p || h <= 0)
      return i.state = {
        style: {}
      }, typeof c == "function" && (i.state = {
        style: l
      }), N(i);
    if (y && y.length)
      i.state = {
        style: y[0].style
      };
    else if (f) {
      if (typeof c == "function")
        return i.state = {
          style: f
        }, N(i);
      i.state = {
        style: u ? O({}, u, f) : f
      };
    } else
      i.state = {
        style: {}
      };
    return i;
  }
  return at(r, [{
    key: "componentDidMount",
    value: function() {
      var e = this.props, i = e.isActive, s = e.canBegin;
      this.mounted = !0, !(!i || !s) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(e) {
      var i = this.props, s = i.isActive, p = i.canBegin, u = i.attributeName, f = i.shouldReAnimate, l = i.to, y = i.from, c = this.state.style;
      if (p) {
        if (!s) {
          var h = {
            style: u ? O({}, u, l) : l
          };
          this.state && c && (u && c[u] !== l || !u && c !== l) && this.setState(h);
          return;
        }
        if (!(H(e.to, l) && e.canBegin && e.isActive)) {
          var g = !e.canBegin || !e.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var m = g || f ? y : e.to;
          if (this.state && c) {
            var b = {
              style: u ? O({}, u, m) : m
            };
            (u && c[u] !== m || !u && c !== m) && this.setState(b);
          }
          this.runAnimation(d(d({}, this.props), {}, {
            from: m,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var e = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), e && e();
    }
  }, {
    key: "handleStyleChange",
    value: function(e) {
      this.changeStyle(e);
    }
  }, {
    key: "changeStyle",
    value: function(e) {
      this.mounted && this.setState({
        style: e
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(e) {
      var i = this, s = e.from, p = e.to, u = e.duration, f = e.easing, l = e.begin, y = e.onAnimationEnd, c = e.onAnimationStart, h = G(s, p, V(f), u, this.changeStyle), g = function() {
        i.stopJSAnimation = h();
      };
      this.manager.start([c, l, g, u, y]);
    }
  }, {
    key: "runStepAnimation",
    value: function(e) {
      var i = this, s = e.steps, p = e.begin, u = e.onAnimationStart, f = s[0], l = f.style, y = f.duration, c = y === void 0 ? 0 : y, h = function(m, b, S) {
        if (S === 0)
          return m;
        var v = b.duration, $ = b.easing, _ = $ === void 0 ? "ease" : $, P = b.style, I = b.properties, M = b.onAnimationEnd, D = S > 0 ? s[S - 1] : b, W = I || Object.keys(P);
        if (typeof _ == "function" || _ === "spring")
          return [].concat(E(m), [i.runJSAnimation.bind(i, {
            from: D.style,
            to: P,
            duration: v,
            easing: _
          }), v]);
        var K = J(W, v, _), q = d(d(d({}, D.style), P), {}, {
          transition: K
        });
        return [].concat(E(m), [q, v, M]).filter(Q);
      };
      return this.manager.start([u].concat(E(s.reduce(h, [l, Math.max(c, p)])), [e.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(e) {
      this.manager || (this.manager = L());
      var i = e.begin, s = e.duration, p = e.attributeName, u = e.to, f = e.easing, l = e.onAnimationStart, y = e.onAnimationEnd, c = e.steps, h = e.children, g = this.manager;
      if (this.unSubscribe = g.subscribe(this.handleStyleChange), typeof f == "function" || typeof h == "function" || f === "spring") {
        this.runJSAnimation(e);
        return;
      }
      if (c.length > 1) {
        this.runStepAnimation(e);
        return;
      }
      var m = p ? O({}, p, u) : u, b = J(Object.keys(m), s, f);
      g.start([l, i, d(d({}, m), {}, {
        transition: b
      }), s, y]);
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props, i = e.children;
      e.begin;
      var s = e.duration;
      e.attributeName, e.easing;
      var p = e.isActive;
      e.steps, e.from, e.to, e.canBegin, e.onAnimationEnd, e.shouldReAnimate, e.onAnimationReStart;
      var u = Y(e, X), f = w.count(i), l = this.state.style;
      if (typeof i == "function")
        return i(l);
      if (!p || f === 0 || s <= 0)
        return i;
      var y = function(h) {
        var g = h.props, m = g.style, b = m === void 0 ? {} : m, S = g.className, v = /* @__PURE__ */ z(h, d(d({}, u), {}, {
          style: d(d({}, b), l),
          className: S
        }));
        return v;
      };
      return f === 1 ? y(w.only(i)) : /* @__PURE__ */ x.createElement("div", null, w.map(i, function(c) {
        return y(c);
      }));
    }
  }]), r;
}(F);
B.displayName = "Animate";
B.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
B.propTypes = {
  from: a.oneOfType([a.object, a.string]),
  to: a.oneOfType([a.object, a.string]),
  attributeName: a.string,
  // animation duration
  duration: a.number,
  begin: a.number,
  easing: a.oneOfType([a.string, a.func]),
  steps: a.arrayOf(a.shape({
    duration: a.number.isRequired,
    style: a.object.isRequired,
    easing: a.oneOfType([a.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), a.func]),
    // transition css properties(dash case), optional
    properties: a.arrayOf("string"),
    onAnimationEnd: a.func
  })),
  children: a.oneOfType([a.node, a.func]),
  isActive: a.bool,
  canBegin: a.bool,
  onAnimationEnd: a.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: a.bool,
  onAnimationStart: a.func,
  onAnimationReStart: a.func
};
export {
  B as default
};
